import React, { useEffect } from 'react';
import { Box, useTheme, alpha } from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

/**
 * SecondaryLoader (v4)
 * • Milky semi-transparent overlay to softly obscure content.
 * • Curved "MARRAKECH RESERVE" text spins slowly counter-clockwise.
 * • Automatically redirects after a 2s delay.
 */
const SecondaryLoader = () => {
  const theme = useTheme();
  const navigate = useNavigate();


  return (
    <Box
      component={motion.div}
      initial={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.5 } }}
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: 1500,
        bgcolor: alpha(theme.palette.common.white, 0.6),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box sx={{ position: 'relative', width: 150, height: 150 }}>
        {/* Slow counter-clockwise curved text */}
        <motion.svg
          viewBox="0 0 100 100"
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}
          animate={{ rotate: [360, 0] }}
          transition={{ duration: 56, ease: 'linear', repeat: Infinity }}
        >
          <defs>
            <path
              id="secondaryCirclePath"
              d="M50 50 m -42 0 a 42 42 0 1 1 84 0 a 42 42 0 1 1 -84 0"
            />
          </defs>
          <text
            fill={theme.palette.common.white}
            fontSize="7"
            fontFamily="'Playfair Display', serif"
            letterSpacing="2"
            textAnchor="middle"
            textLength="251"
            lengthAdjust="spacingAndGlyphs"
          >
            <textPath href="#secondaryCirclePath" startOffset="0%">•</textPath>
            <textPath href="#secondaryCirclePath" startOffset="25%">MARRAKECH&nbsp;RESERVE</textPath>
            <textPath href="#secondaryCirclePath" startOffset="50%">•</textPath>
            <textPath href="#secondaryCirclePath" startOffset="75%">MARRAKECH&nbsp;RESERVE</textPath>
          </text>
        </motion.svg>

        {/* Static tree crest */}
        <Box
          component="img"
          src="https://brokepiggytoken.xyz/wp-content/uploads/2025/07/tree_logo_loader.png"
          alt="Marrakech Reserve logo"
          sx={{
            width: '70%',
            height: '70%',
            objectFit: 'contain',
            position: 'absolute',
            top: '15%',
            left: '15%',
          }}
        />
      </Box>
    </Box>
  );
};

export default SecondaryLoader;
